module.exports = __webpack_public_path__ + "static/img/client_upgraded_cn1.77a16383.png";